// extracted by mini-css-extract-plugin
var _1 = "SelectDropdownEntityListItemIcons-modulechip__UXLqN";
var _2 = "SelectDropdownEntityListItemIcons-moduleicons__OizaI";
export { _1 as "chip", _2 as "icons" }
